<template>
  <div class="login-div">
    <md-card>
      <md-card-area>
        <md-card-header>
          <div class="md-title">Login</div>
        </md-card-header>

        <md-card-content>
          <form style="width:350px">
            <md-input-container>
              <md-icon>person</md-icon>
              <label>Email</label>
              <md-input required type="email" v-model="payload.email" ref="email"></md-input>
            </md-input-container>

            <md-input-container md-has-password>
              <md-icon>remove_red_eye</md-icon>
              <label>Password</label>
              <md-input required type="password" v-model="payload.password" ref="password"></md-input>
            </md-input-container>
            <!-- <md-checkbox v-model="payload.rememberMe" class="md-primary">Remember Me</md-checkbox> -->
          </form>
        </md-card-content>
      </md-card-area>

      <md-card-actions>
        <md-button class="md-primary" @click="login">LOGIN</md-button>
      </md-card-actions>
    </md-card>

    <md-dialog-confirm
      ref="confirm_dailog"
      :md-title="error.title"
      :md-content-html="error.message"
      :md-ok-text="error.okText"
      :md-cancel-text="error.cancelText"
      @open="onOpen"
      @close="onClose"
    ></md-dialog-confirm>
  </div>
</template>


<script>
import { deviceType } from "../../../helper/enum/deviceType.js";

export default {
  created() {},
  beforeMount() {
    this.$store.dispatch("setCurrentRoute", "/login");
  },
  mounted() {
    if (this.$auth.redirect()) {
      this.redirect = this.$auth.redirect().from.name;
    }
  },
  beforeDestroy() {},
  destroyed() {},

  data() {
    return {
      payload: {
        email: "",
        password: "",
        rememberMe: false,
        redirect: ""
      },
      error: {
        title: "Something went wrong",
        message: "All fields are required. Fill in all details before login",
        okText: "OK",
        cancelText: "CANCEL"
      }
    };
  },
  components: {},
  computed: {},
  methods: {
    openDialog() {
      this.$refs.confirm_dailog.open();
    },
    closeDialog() {
      this.$refs.confirm_dailog.close();
    },
    onOpen() {},
    onClose(type) {},
    DeviceType() {
      return this.$store.getters.appDeviceType;
    },
    login() {
      const { email, password, rememberMe, redirect } = this.payload;
      // const _redirect = "/dashboard";
      const _redirect =
        redirect != null && redirect != "" ? redirect : "/dashboard";
      if (email && password && password.length > 0) {
        // this.$store.dispatch("setIsProgressVisible", true);
        this.$auth.login({
          headers: {
            "Content-Type": "application/json"
          },
          data: {
            username: email,
            password
          },
          rememberMe: rememberMe,
          redirect: _redirect,
          success(res) {
            // console.log("res", res);
            this.$router.push("/couponlist");
            // return false;
            if (res.data.status === 0) {
              this.$store.dispatch("setIsProgressVisible", false);
              this.error.message = "Wrong login credentials";
              this.openDialog();
              return;
            }
            this.$store.dispatch("setUserEmail", res.data.email);
            // console.log("checkPermission>>>>", res.data.permissions)
            res.data.permissions.forEach(element => {
              this.$mcdStore.set("userEmail", res.data.email);
              if (element === "admin")
                this.$mcdStore.set("adminPermission", true);
              else if (element === "add")
                this.$mcdStore.set("addPermission", true);
              else if (element === "edit_failed")
                this.$mcdStore.set("editPermission", true);
              else if (element === "edit_success")
                this.$mcdStore.set("successfulPermission", true);
              else if (element === "upload")
                this.$mcdStore.set("uploadPermission", true);
              else if (element === "cron")
                this.$mcdStore.set("cronPermission", true);
              else if (element === "editCountry")
                this.$mcdStore.set("editCountry", true);
              else if (element === "log")
                this.$mcdStore.set("logPermission", true);
              else if (element === "junk_lead")
                this.$mcdStore.set("junkLeadPermission", true);
            }, this);
            if (res.data.status === 0) {
              this.error.title = "Error";
              this.error.message = res.data.message;
              this.openDialog();
            }
            if (res.data.status !== 0 && res.status === 200) {
              if (this.DeviceType == deviceType.PHONE) {
                this.$store.dispatch("setSidebarMargin", 0);
              } else {
                this.$store.dispatch("setSidebarMargin", 300);
              }
              this.$events.emit("forceShow", true);
            }
          },
          error(error) {
            this.error.title = "Error";
            this.error.message = "Something went wrong! Please try again later";
            this.openDialog();
            this.$store.dispatch("setIsProgressVisible", false);
          }
        });
      } else {
        this.openDialog();
      }
    }
  }
};
</script>


<style>
.login-div {
  max-width: 400px;
  margin: auto;
  margin-top: 100px;
}

.md-primary {
  background-color: #2196f3 !important;
  color: #fff !important;
}
</style>






// WEBPACK FOOTER //
// src/components/view/login/login.vue